import request from "../request";

import { REACT_BASE_URL_GAMA_USERS } from "../url";

export const getRolesRequest = async ({
  orderBy = "DESC",
  orderByProperty = "createdAt",
  ...query
}) => {
  return request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles?page=${
      query?.currentPage || 1
    }&pageSize=${query?.pageSize || 7}&orderBy=${
      orderBy || "DESC"
    }&orderByProperty=${orderByProperty || "createdAt"}&search=${
      query?.search || ""
    }`,
    method: "GET",
  });
};

export const getRoleRequest = async (roleId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles/${roleId}`,
    method: "GET",
  });
};

export const getMineRoleRequest = async (roleId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles/mine/${roleId}`,
    method: "GET",
  });
};

export const getPermissionsRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/permissions`,
    method: "GET",
  });
};

export const getAllPermissionsRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/all-permissions`,
    method: "GET",
  });
};

export const createRoleRequest = async (payload) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles`,
    method: "POST",
    data: payload,
  });
};

export const updateRoleRequest = async (roleId, payload) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles/${roleId}`,
    method: "PATCH",
    data: payload,
  });
};

export const removeRoleRequest = async (roleId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/roles/${roleId}`,
    method: "DELETE",
  });
};
